import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
    LoadAllCriterionConfigurations,
    SaveConfiguration
};

function SaveConfiguration(allConfiguration, onSuccess, onError){

    var headers = getAuthHeader();
    
    axios
        .put(process.env.VUE_APP_BASE_API_URL + "/klauseltypes", allConfiguration, headers)
        .then(() => {
            onSuccess();
        })
        .catch(error => {
            onError(error);
        }
    );
}

function LoadAllCriterionConfigurations(onSuccess, onError, loadAll){

    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + "/klauseltypes" + (loadAll != null && loadAll == false ? "?loadAll=false" : ""), headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        }
    );
}
